module.exports = {
  delay: 500,
  border: {
    radius: 'radius.lg',
  },
};
